import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Country} from '../models/country';
import {of, BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CountryRegionService {
  // NEW — reactive source of truth. Replaces the plain array so late subscribers
  // (e.g. BillingAddressInformationComponent mounting before the HTTP fetch
  // resolves — which happens on the 3DS-resume path, since sessionStorage's
  // 'countries' cache gets wiped by app.component.ts's ngOnDestroy right before
  // the redirect to the bank's ACS page) still get the data once it arrives.
  private countryListSubject = new BehaviorSubject<any[]>([]);
  countryList$ = this.countryListSubject.asObservable();

  get countryList(): any[] {
    return this.countryListSubject.value;
  }
  set countryList(value: any[]) {
    this.countryListSubject.next(value || []);
  }

  constructor(private http: HttpClient) {
  }

  getCountries() {
    return this.countryList.map(country => {
      return {name: country.countryName, id: country.countryIsoCode};
    });
  }

  loadUsaStates() {
    const states = this.countryList.filter(cntry => cntry.countryIsoCode === 'US')[0].stateProvince;
    return of(states);
  }

  loadCountryStates(country: string) {
    const states = this.countryList.filter(cntry => cntry.countryIsoCode === country)[0].stateProvince;
    return states.map(d => {
      return { name: d.stateName, id: d.stateCode };
    });
  }

  loadCaStates() {
    const states = this.countryList.filter(cntry => cntry.countryIsoCode === 'CA')[0].stateProvince;
    return of(states);
  }

  loadCountries() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    this.http.get<Country[]>(environment.PAYMENT_UI + `/epms/countries`, httpOptions).subscribe({next:data => {
      const usaCountry = data.filter(cntry => cntry.countryIsoCode === 'US');
      const nonUsaCountry = data.filter(cntry => cntry.countryIsoCode !== 'US');
      this.countryList = [...usaCountry, ...nonUsaCountry];   // setter now emits via BehaviorSubject
      sessionStorage.setItem('countries', (JSON.stringify(this.countryList)));
    }, error:err => {
      console.log('error while loading the countries');
      this.countryList = [];
      }});
  }
}